import { useState } from "react";
import { Moon, Sun } from "lucide-react";

export default function ThemeToggle() {
  const [dark, setDark] = useState(() => document.documentElement.classList.contains("dark"));

  const toggle = () => {
    const next = !dark;
    setDark(next);
    document.documentElement.classList.toggle("dark", next);
    try {
      localStorage.setItem("sf-theme", next ? "dark" : "light");
    } catch {}
  };

  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label={dark ? "Passer au thème clair" : "Passer au thème sombre"}
      title={dark ? "Passer au thème clair" : "Passer au thème sombre"}
      className="inline-flex items-center justify-center border border-ink/20 p-2.5 text-ink transition-colors duration-300 hover:border-bronze hover:text-bronze"
    >
      {dark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
